import moment from 'moment'

moment.locale('pt-br')

const momentFilter = function(date: any, format: string) {
  if (date) return moment(date).format(format)
}

export default momentFilter
